import { useNavigate } from 'react-router-dom';

export function useAuthGuard() {
  const navigate = useNavigate();

  const checkAuth = (): boolean => {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (!token) {
      if (window.confirm('이 기능을 사용하려면 회원가입이 필요합니다.\n회원가입 페이지로 이동하시겠습니까?')) {
        navigate('/register');
      }
      return false;
    }
    return true;
  };

  return checkAuth;
}
